import axiosInstance from "../../../constants/axiosInstance";
import { LogbookTemplatesPage } from '../types/loogBookTypes';

export const postFormData = async (url: string, formData: FormData) => {
    const { data } = await axiosInstance().post(url, formData);
    return data;
};

export const fetchLogbookOptions = async () => {
    const { data } = await axiosInstance().get("/ocr/preFormCreateOrUpdateLogbookTemplate");
    return data.data;
};

export const fetchTemplateDetails = async (logbookTemplateId: string) => {
    const { data } = await axiosInstance().post(`/ocr/getLogbookTemplateDetails`, { logbookTemplateId });
    return data.data;
};

export const saveTemplate = (formData: FormData) => {
    return postFormData('/ocr/createOrUpdateLogbookTemplate', formData);
};

export const fetchTemplatesList = async ({ pageParam = 1, queryKey, limit }: any): Promise<LogbookTemplatesPage> => {
    const [, searchString] = queryKey;
    const { data } = await axiosInstance().post(`/ocr/getListOfLogbookTemplates`, {
        logbookTemplate: searchString,
        pageNumber: pageParam,
        limit,
    });
    return {
        logbookTemplates: data.data.listOfLogbookTemplates,
        totalPages: data.data.totalPages,
        totalCount: data.data.totalCount,
        currentPage: pageParam,
    };
};

export const deleteTemplate = async (logbookTemplateId: string) => {
    const { data } = await axiosInstance().post(`/ocr/deleteLogbookTemplate`, { logbookTemplateId });
    return data;
};